import React from 'react';
import { Modal, Button } from 'antd';

export default function RepairDeleteModal({ open, onCancel, onConfirm, repair, loading }) {
  return (
    <Modal
      title="Delete repair"
      open={!!open}
      onCancel={onCancel}
      footer={[
        <Button
          key="delete"
          danger
          onClick={onConfirm}
          loading={loading}
          className="app-btn-delete"
        >
          Delete
        </Button>,
        <Button key="cancel" onClick={onCancel} className="app-btn-cancel">
          Cancel
        </Button>,
      ]}
      destroyOnClose
    >
      {repair && (
        <>
          Are you sure you want to delete this repair
          {repair.issue?.trim() ? (
            <>
              {' '}
              (<strong>{repair.issue.trim()}</strong>)
            </>
          ) : null}
          {repair.givenTo ? ` — given to ${repair.givenTo}` : ''}?
        </>
      )}
    </Modal>
  );
}
